// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';
import { User } from 'models/admin';

interface GetAdminUsersRequest {
  keyword: string;
}

type GetAdminUsersResponse = User[];

export const useSearchUser = () => {
  const getAdminUsers = (_data: GetAdminUsersRequest): Promise<GetAdminUsersResponse> => rejectServiceClosed();

  return { getAdminUsers };
};
